module.exports = __webpack_public_path__ + "static/media/CTLA_6-383w.4b1596fb.jpg";